import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/help.png'
import _imports_1 from '@/assets/images/returnTopBtn.png'


const _withScopeId = n => (_pushScopeId("data-v-1d68e4f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "container",
  class: "portal-site__container"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "help-text" }, [
  /*#__PURE__*/_createTextVNode(" 咨询电话 "),
  /*#__PURE__*/_createElementVNode("p", null, "0551-62220000")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "help-phone",
  src: _imports_0,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]

import { ref, watch } from "vue";
import AppHeader from "./components/app-header.vue";
import AppFooter from "./components/app-footer.vue";
import { useRoute } from "vue-router";


import { defineComponent } from "vue";

const __default__ = defineComponent({
  name: "PortalSiteLayout",
});


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const route = useRoute();
const isHome = ref(false);

const runHomePage = () => {
  const oTop = document.body.scrollTop || document.documentElement.scrollTop;
  if (oTop > 0) {
    document.body.scrollTop = document.documentElement.scrollTop = oTop - 100;
    setTimeout(runHomePage, 10);
  }
};

watch(
  () => route.fullPath,
  (newVal) => {
    isHome.value = newVal === "/";
  },
  { deep: true }
);

return (_ctx: any,_cache: any) => {
  const _component_a_tooltip = _resolveComponent("a-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!isHome.value)
      ? (_openBlock(), _createBlock(AppHeader, {
          key: 0,
          class: "portal-site__header"
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_a_tooltip, { placement: "left" }, {
      title: _withCtx(() => [
        _hoisted_2
      ]),
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }),
    _createElementVNode("div", {
      class: "return-top-btn",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (runHomePage()))
    }, _hoisted_5),
    _renderSlot(_ctx.$slots, "default"),
    _createVNode(AppFooter)
  ]))
}
}

})